import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconTablet$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTablet extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '2728f7cc8d3076b0cb349d478646adb169f03118', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e12f35f5f7fbf01acf7d353d1b1021fda32f2ae8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '433da56da079e8953fd1aa39071e30814e4ffd47', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.5 3a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-14a.5.5 0 0 0-.5-.5zM11 17a1 1 0 1 1 0-2 1 1 0 0 1 0 2m4.5-3h-9V4.5h9z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-tablet", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-tablet"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-tablet":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTablet$1);
            }
            break;
    } });
}

const CosmosIconTablet = CosmosIconTablet$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTablet, defineCustomElement };
